import { render } from "./ViewCategoryModal.vue?vue&type=template&id=7b89d1eb&scoped=true"
import script from "./ViewCategoryModal.vue?vue&type=script&lang=js"
export * from "./ViewCategoryModal.vue?vue&type=script&lang=js"

import "./ViewCategoryModal.vue?vue&type=style&index=0&id=7b89d1eb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b89d1eb"]])

export default __exports__